export const routes = {
    ORDERS: '/orders',
    TOURS: '/tours',
    TOURSERVICE: '/tourservice',
    WELCOME: '/welcome',
} as const;
